<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import InputBox from '../../components/InputBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// this is Q14 in e-confluence page for call survey
export default defineComponent({
  name: 'SurveyQ72',
  components: {
    InputBox,
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'supportUnhelpfulnessOtherReason',
      'isCallSurvey'
    ]),
    hasValidOtherReason (): boolean {
      return Boolean(this.supportUnhelpfulnessOtherReason?.trim());
    }
  },
  methods: {
    ...mapActions([
      'changeSupportUnhelpfulnessOtherReason'
    ]),
    saveText (event: string) {
      this.changeSupportUnhelpfulnessOtherReason(event);
    },
    nextScreen () {
      // navigate user to Q8 which is Q15 in e-confluence page for call survey
      router.push({ path: '/survey/question8/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div>
        <p class="with-margin">{{ isCallSurvey ? $t('survey_072_01_call') : $t('survey_072_01') }}</p>
        <input-box @change="saveText" :text="supportUnhelpfulnessOtherReason"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!hasValidOtherReason"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
